import React from "react";
import { Skeleton as MuiSkeleton } from "@mui/material";
import styled from "@emotion/styled";

const SkeletonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -${({ spacing }) => spacing || 0}px;
`;

const SkeletonItem = styled.div`
  padding: ${({ spacing }) => spacing || 0}px;
  flex-basis: ${({ col }) => `${(col / 12) * 100}%`};
  max-width: ${({ col }) => `${(col / 12) * 100}%`};
  box-sizing: border-box;
`;

const Skeleton = ({
  type = "text",
  rows = 1,
  height = 24,
  col = 12,
  radius = 0,
  hidden = false,
  ...props
}) => {
  const renderSkeleton = () => {
    const maxRows = rows || Math.floor((props.height || 300) / height);
    const containerHeight = maxRows * height;
    const containerWidth = "100%";

    if (type === "image") {
      // For image type, maintain your existing logic

      return (
        <MuiSkeleton
          variant="rectangular"
          height={containerHeight}
          width={containerWidth}
          animation="wave"
          style={{
            borderRadius: radius,
            marginBottom: "0.5rem",
            ...props.style,
          }}
          {...props}
        />
      );
    } else {
      // For text type, use the rows prop to determine how many skeletons to render
      return (
        <div style={{ width: "100%" }}>
          {Array.from({ length: maxRows }).map((_, index) => (
            <MuiSkeleton
              key={index}
              variant="text"
              animation="wave"
              height={height}
              width="100%"
              style={{
                marginBottom: "0.5rem",
                ...props.style,
              }}
            />
          ))}
        </div>
      );
    }
  };

  return (
    <SkeletonItem
      col={col}
      style={{ visibility: hidden ? "hidden" : "visible" }}
      {...props}
    >
      {renderSkeleton()}
    </SkeletonItem>
  );
};

const SkeletonGrid = ({ children, spacing, ...props }) => {
  return (
    <SkeletonContainer spacing={spacing}>
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            ...props,
            ...child.props,
            spacing,
          });
        }
        return child;
      })}
    </SkeletonContainer>
  );
};

export { SkeletonGrid, Skeleton };
